import { memo } from 'react';

const AccessibilityIllustration = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={144} height={144} fill="none" {...props}>
        <mask
            id="a"
            width={125}
            height={110}
            x={10}
            y={17}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance',
            }}
        >
            <path fill="#fff" d="M134.117 17.224H10.164v109.553h123.953V17.224Z" />
        </mask>
        <g mask="url(#a)">
            <path
                fill="#B26E3D"
                d="M64.59 66.575a2.414 2.414 0 0 1-1.653-.65l-5.29-4.93a2.429 2.429 0 0 1-.122-3.43 2.424 2.424 0 0 1 3.427-.123l5.29 4.93a2.429 2.429 0 0 1-1.653 4.203ZM122.402 115.33a2.425 2.425 0 0 1-2.402-2.128l-.813-6.549a2.425 2.425 0 1 1 4.812-.598l.813 6.548a2.426 2.426 0 0 1-2.41 2.727Z"
            />
            <path
                fill="#474747"
                d="m103.614 111.911 1.078 10.826h11.922l-2.205-22.121-.019-.198-.033-.196a11.149 11.149 0 0 0-11.025-9.334c-5.932 0-10.835 4.645-11.161 10.575v.041l-.878 21.234h11.874l.447-10.826v-.001Z"
            />
            <path
                fill="#ABABAB"
                d="M121.591 110.806a4.45 4.45 0 0 1-4.448-4.436c-.027-7.085-.479-11.927-1.419-15.24-.813-2.862-1.954-4.594-3.683-7.217l-.359-.546c-1.163-1.768-2.267-2.934-3.195-3.37-.573-.269-1.144-.281-2.186-.278h-.208a4.45 4.45 0 0 1-4.448-4.453 4.45 4.45 0 0 1 4.448-4.452h.194c1.425-.003 3.581-.006 5.984 1.124 2.483 1.168 4.722 3.306 6.846 6.536l.352.536c4.277 6.487 6.51 10.648 6.575 27.327a4.45 4.45 0 0 1-4.432 4.469H121.591Z"
            />
            <path
                fill="#ABABAB"
                d="M104.413 96.07a5.333 5.333 0 0 0 5.331-5.336 5.334 5.334 0 0 0-5.331-5.336 5.334 5.334 0 0 0-5.331 5.336 5.333 5.333 0 0 0 5.331 5.335Z"
            />
            <path
                fill="#ABABAB"
                d="M97.994 78.07a7.1 7.1 0 0 0 6.72 7.46c3.913.204 7.25-2.808 7.454-6.725.203-3.918-3.047-3.216-6.961-3.418-3.914-.203-7.011-1.235-7.213 2.683Z"
            />
            <path
                fill="#ABABAB"
                d="m99.107 91.273 10.544.452 2.445-12.213-14.104-.74 1.115 12.501Z"
            />
            <path
                fill="#B26E3D"
                d="M108.252 67.866a2.315 2.315 0 0 1-3.334.336 2.335 2.335 0 0 1-.375-3.104 2.308 2.308 0 0 1 3.302-.48 2.32 2.32 0 0 1 .827 2.38 2.298 2.298 0 0 1-.422.868h.002Z"
            />
            <path
                fill="#474747"
                d="M105.824 64.205c.142.346.406.974 1.11 1.964.341.478.9 1.239 1.382 1.615.172-.244.293-.507.36-.782a2.325 2.325 0 0 0-.829-2.386 2.294 2.294 0 0 0-1.372-.487c-.22-.005-.438.02-.649.078l-.002-.002Z"
            />
            <path
                fill="#474747"
                d="M112.949 66.165a2.565 2.565 0 0 1-3.706.362 2.583 2.583 0 0 1-.493-3.3 2.56 2.56 0 0 1 3.747-.663 2.573 2.573 0 0 1 .452 3.6Z"
            />
            <path
                fill="#ABABAB"
                d="M71.122 64.403c-.972-.74-1.563-1.238-1.601-1.268a4.448 4.448 0 0 0-6.27.526 4.455 4.455 0 0 0 .524 6.275c.138.117 1.668 1.403 3.982 3.043l1.886-.589 1.478-7.987h.001ZM105.324 70.814c-1.323 0-3.004.2-5.133.457-4.915.587-12.247 1.464-17.358-.143l-.15 9.14c2.454.5 5.021.683 7.539.683 4.036 0 7.94-.468 11.026-.838 1.689-.202 3.284-.393 4.076-.393a4.45 4.45 0 0 0 4.449-4.452 4.45 4.45 0 0 0-4.449-4.452v-.002Z"
            />
            <path
                fill="#00D639"
                d="M128.281 126.776H85.847a5.844 5.844 0 0 1-5.835-5.84V59.203c0-3.22 2.617-5.84 5.835-5.84h42.436c3.217 0 5.835 2.62 5.835 5.84v61.733c0 3.22-2.618 5.84-5.835 5.84h-.002ZM85.847 57.403c-.993 0-1.8.809-1.8 1.802v61.733c0 .993.807 1.802 1.8 1.802h42.436c.993 0 1.8-.809 1.8-1.802V59.203c0-.993-.807-1.801-1.8-1.801H85.847v.001Z"
            />
            <path
                fill="#303030"
                d="M123.499 114.501a.957.957 0 1 0-1.903.211l.89 8.026h1.93l-.913-8.236-.004-.001Z"
            />
            <path
                fill="#00D639"
                d="M65.295 75.013H18.55c-4.625 0-8.386-3.766-8.386-8.393V34.902c0-4.629 3.763-8.393 8.386-8.393h46.745c4.624 0 8.386 3.766 8.386 8.393V66.62c0 4.629-3.763 8.393-8.386 8.393ZM18.55 30.548a4.357 4.357 0 0 0-4.35 4.354V66.62c0 2.4 1.952 4.353 4.35 4.353h46.745a4.357 4.357 0 0 0 4.35-4.353V34.902c0-2.4-1.952-4.354-4.35-4.354H18.55Z"
            />
            <path
                fill="#474747"
                d="M37.313 59.832c-6.62-.741-11.404-6.738-10.663-13.364.741-6.627 6.732-11.415 13.353-10.673 6.62.741 11.404 6.738 10.663 13.364-.74 6.627-6.732 11.415-13.352 10.672v.001Zm2.494-22.286c-5.657-.634-10.775 3.456-11.408 9.118-.633 5.661 3.453 10.784 9.11 11.417 5.657.634 10.775-3.455 11.408-9.117.633-5.662-3.453-10.785-9.11-11.418Z"
            />
            <path
                fill="#474747"
                d="M50.102 52.184a1.438 1.438 0 0 0-1.551 2.42l11.715 7.524a1.438 1.438 0 0 0 1.551-2.42l-11.715-7.524Z"
            />
            <path
                fill="#00D639"
                d="M125.548 47.897H89.3c-3.846 0-6.976-3.13-6.976-6.981v-16.71c0-3.85 3.129-6.982 6.976-6.982h36.248c3.845 0 6.975 3.13 6.975 6.981v16.71c0 3.85-3.128 6.982-6.975 6.982ZM89.3 21.264a2.944 2.944 0 0 0-2.94 2.941v16.71a2.944 2.944 0 0 0 2.94 2.942h36.248c1.62 0 2.939-1.32 2.939-2.941v-16.71a2.944 2.944 0 0 0-2.939-2.942H89.3Z"
            />
            <path fill="#919191" d="M107.414 36.858h8.59v-8.597h-8.59v8.597Z" />
            <path fill="#ABABAB" d="M98.824 36.858h8.59v-8.597h-8.59v8.597Z" />
            <path fill="#C6C6C6" d="M90.234 36.858h8.59v-8.597h-8.59v8.597Z" />
            <path fill="#777" d="M116.004 36.858h8.59v-8.597h-8.59v8.597Z" />
            <path
                fill="#00D639"
                d="M66.21 118.886H22.856a4.562 4.562 0 0 1-4.555-4.559V87.735a4.562 4.562 0 0 1 4.555-4.559H66.21a4.562 4.562 0 0 1 4.554 4.559v26.592a4.562 4.562 0 0 1-4.554 4.559Zm-43.354-31.67a.519.519 0 0 0-.519.519v26.592c0 .287.232.519.519.519H66.21a.518.518 0 0 0 .518-.519V87.735a.519.519 0 0 0-.518-.52H22.856Z"
            />
            <path
                fill="#5E5E5E"
                d="M37.16 96.03v9.762l7.71 4.724V91.463l-7.71 4.567ZM51.379 108.422a.866.866 0 0 1-.7-1.372c.027-.038 1.966-2.775 2.037-6.218.072-3.45-1.803-6.32-1.82-6.35a.863.863 0 0 1 .241-1.197.862.862 0 0 1 1.196.24c.089.133 2.195 3.336 2.112 7.344-.083 4.006-2.273 7.069-2.367 7.196a.862.862 0 0 1-.7.357ZM48.55 105.924a.863.863 0 0 1-.754-1.283c.011-.02.877-1.617.918-3.626.041-2.014-.784-3.688-.792-3.704a.867.867 0 0 1 .383-1.16.861.861 0 0 1 1.158.38c.041.083 1.028 2.061.977 4.519-.051 2.458-1.091 4.35-1.134 4.43a.862.862 0 0 1-.756.444Z"
            />
            <path
                fill="#5E5E5E"
                d="M54.301 111.319a.866.866 0 0 1-.676-1.404c.036-.046 3.08-3.94 3.18-8.846.103-4.91-2.843-8.992-2.871-9.033a.866.866 0 0 1 .184-1.208.862.862 0 0 1 1.206.183c.135.184 3.322 4.58 3.207 10.093-.114 5.513-3.417 9.712-3.557 9.888a.86.86 0 0 1-.676.325l.003.002ZM31.09 95.811h3.574v9.547H31.09a2.08 2.08 0 0 1-2.078-2.081v-5.385c0-1.15.932-2.08 2.078-2.08Z"
            />
            <path
                fill="#B26E3D"
                d="M60.328 62.324h-.05a.823.823 0 0 1-.77-.871c.035-.59.017-2.345-.48-3.375a.823.823 0 0 1 1.478-.716c.79 1.63.648 4.088.641 4.191a.822.822 0 0 1-.819.772v-.001Z"
            />
            <path
                fill="#B26E3D"
                d="M61.93 63.64h-.051a.823.823 0 0 1-.77-.87c.035-.591.018-2.345-.48-3.375a.823.823 0 0 1 1.479-.717c.789 1.63.647 4.088.64 4.192a.822.822 0 0 1-.818.772v-.002Z"
            />
            <path fill="#B26E3D" d="m63.014 61.392-2.465-.466-.24 2.004 1.346.282 1.359-1.82Z" />
        </g>
    </svg>
);
export default memo(AccessibilityIllustration);
